import { Button, Modal, Typography, message } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { userReportLinkExp, userReports } from "../../actions/reports/reports";
import block from "../../assets/icons/block.png";
import warn from "../../assets/icons/warning.png";
import { objectToFormData } from "../../utils";
import TableWrap from "../Common/Table/Table";
// import moment from "moment";

import { useHistory } from "react-router-dom";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import "./report.css";

message.config({
  maxCount: 3,
});

const Title = Typography.Title;

const LinkExpensesToReport = (props) => {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = React.useState([]);
  const [reportsData, setReportsData] = React.useState([]);
  const [violations, setViolations] = React.useState([]);
  const [showViolations, setShowViolations] = React.useState(false);
  const reportsResponse = useSelector(
    (state) => state.reports.userReports || {},
  );
  const history = useHistory();
  React.useEffect(() => {
    dispatch(userReports({ status: "unsubmitted" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { response: { reports = [] } = {}, status = false } = {} } =
      reportsResponse;
    if (status) {
      setReportsData(reports);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsResponse]);

  const columns = [
    {
      title: "Report ID",
      dataIndex: "report_number",
      key: "report_number",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    },
    {
      title: "Date and Time",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedData,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedData(selectedRowKeys);
    },
  };

  const handleClearList = () => {
    setSelectedData([]);
  };

  const handleAddExp = () => {
    const payload = {};
    payload.transactions = [props.expense_id];
    payload.id = selectedData[0];
    dispatch(userReportLinkExp(objectToFormData({ ...payload })));
  };

  return (
    <div className="expenses-table">
      {selectedData.length ? (
        <>
          <Button
            type="default"
            ghost
            className="approve-add-btn mb1"
            onClick={() => handleClearList()}
          >
            Clear Selection
          </Button>
          <Button
            onClick={() => {
              endpoint
                .post(
                  apis.validate_expense,
                  {
                    transaction_ids: [props.expense_id],
                  },
                  { skipSuccessMessage: true },
                )
                .then((res) => {
                  let txns = res.data?.response?.transactions || [];
                  let policies = [];
                  txns?.forEach((ele) => {
                    policies = [
                      ...policies,
                      ...ele?.policies?.map(
                        (e) => e.is_blocked && e.errors?.length,
                      ),
                    ];
                  });

                  if (policies?.filter((ele) => ele)?.length) {
                    setShowViolations(true);
                    setViolations(txns);
                  } else {
                    handleAddExp();
                  }
                });
            }}
            className="floatRight ml1 primaryButton"
          >
            Add to {selectedData.length > 1 ? selectedData.length : ""} Report
          </Button>
        </>
      ) : null}
      <Modal
        title={<Title level={4}>Policy Violation Information</Title>}
        visible={showViolations}
        onCancel={() => {
          setShowViolations(false);
        }}
        footer={[]}
      >
        <div className="violations">
          {violations?.map((ele, idx) => (
            <div className="item">
              {idx + 1}. {ele.transaction_number} -
              {ele.policies?.map((itm) =>
                itm.errors.map((e) => (
                  <span className={itm.is_warning ? "warn" : ""}>
                    <img
                      src={itm.is_warning ? warn : block}
                      alt=""
                      width={12}
                    />{" "}
                    {e}
                  </span>
                )),
              )}
            </div>
          ))}
        </div>
      </Modal>
      <TableWrap
        rowKey="id"
        columns={columns}
        data={reportsData.slice(0, 9)}
        className="tableStyled"
        pagination={false}
        rowSelection={{
          type: "radio",
          ...rowSelection,
        }}
      />
      {reportsData?.length === 0 && (
        <div className="filter-btns mt2 floatRight">
          <Button
            className="primaryButton"
            onClick={() => {
              history.push("/reports", {
                createNew: true,
                expense_id: props.expense_id,
              });
            }}
          >
            Add Report
          </Button>
        </div>
      )}
    </div>
  );
};

export default LinkExpensesToReport;
